export default __webpack_public_path__ + "static/media/FootballTonic.aa4b82acb1c99fc03746523fca67a92a.webp";